// Turn an event title into a URL-friendly slug (Unicode-aware, so Tamil titles work too).
// Uses Intl.Segmenter to keep grapheme clusters (base letter + combining marks) intact,
// otherwise Tamil vowel signs get split off into their own hyphenated fragments.
export const slugify = (text = "") => {
  const str = text.toString().trim().toLowerCase();

  if (typeof Intl !== "undefined" && Intl.Segmenter) {
    const segmenter = new Intl.Segmenter(undefined, { granularity: "grapheme" });
    const words = [];
    let current = "";

    for (const { segment } of segmenter.segment(str)) {
      if (/[\p{L}\p{N}]/u.test(segment)) {
        current += segment;
      } else if (current) {
        words.push(current);
        current = "";
      }
    }
    if (current) words.push(current);

    return words.join("-");
  }

  return str.replace(/[^\p{L}\p{N}]+/gu, "-").replace(/^-+|-+$/g, "");
};

// Build the "/events/title-slug" path for an event article (no id in the URL)
export const buildEventPath = (event) => `/events/${slugify(event?.article_title)}`;

// The API has no slug lookup, so find the matching article out of a fetched
// list by comparing its title-slug against the URL param.
export const findEventBySlug = (events = [], slug = "") =>
  events.find((event) => slugify(event.article_title) === slug);
